/* Pure Wine: Corporate page. Small jobs, none of them needed for the form to work:
   1. The Gifting and Events buttons choose the matching answer in "What is it for?" (radio buttons, or the
      dropdown if the section is set that way). A link from another page can do the same with ?for=Gifting.
   2. The date field will not accept a day that has passed. "Today" is worked out here, in New York time,
      because Shopify caches pages and Liquid would print a stale date.
   3. The holiday order-by line is shown only between its two dates, New York time, for the same reason.
      ?pw_now=2026-11-15 previews any day. In the theme editor the line is always shown.
   4. After sending, focus moves to the thank-you panel. */
(function () {
  'use strict';
  var TZ = 'America/New_York';
  var MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  function nyToday() {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day };
  }

  /* Reads a typed date forgivingly: 2026-11-01, 11/1/2026, 11/1, November 1, Nov 1 2026, 1 November.
     Without a year it uses the year given. Returns null when it cannot be read. */
  function parseDay(str, year) {
    if (!str) return null;
    var s = String(str).trim().toLowerCase().replace(/,/g, ' ').replace(/\s+/g, ' ');
    var m, y, mo, d, hasYear = false;
    if ((m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/))) { y = +m[1]; mo = +m[2]; d = +m[3]; hasYear = true; }
    else if ((m = s.match(/^(\d{1,2})[\/.-](\d{1,2})(?:[\/.-](\d{2,4}))?$/))) { mo = +m[1]; d = +m[2]; if (m[3]) { y = +m[3]; if (y < 100) y += 2000; hasYear = true; } }
    else if ((m = s.match(/^([a-z]+)\.? (\d{1,2})(?: (\d{4}))?$/))) { mo = MONTHS.indexOf(m[1].slice(0, 3)) + 1; d = +m[2]; if (m[3]) { y = +m[3]; hasYear = true; } }
    else if ((m = s.match(/^(\d{1,2}) ([a-z]+)\.?(?: (\d{4}))?$/))) { d = +m[1]; mo = MONTHS.indexOf(m[2].slice(0, 3)) + 1; if (m[3]) { y = +m[3]; hasYear = true; } }
    else return null;
    if (!hasYear) y = year;
    if (!(mo >= 1 && mo <= 12 && d >= 1 && d <= 31)) return null;
    return { y: y, m: mo, d: d, hasYear: hasYear };
  }
  function num(o) { return o.y * 10000 + o.m * 100 + o.d; }

  function today() {
    try {
      var q = new URLSearchParams(location.search).get('pw_now');
      if (q) { var o = parseDay(q.slice(0, 10), nyToday().y); if (o) return o; }
    } catch (e) { /* older browsers */ }
    return nyToday();
  }

  function season(root) {
    root.querySelectorAll('[data-pw-cp-season]').forEach(function (el) {
      var now, start, end;
      try { now = today(); } catch (e) { el.hidden = true; return; }
      start = parseDay(el.getAttribute('data-start'), now.y);
      end = parseDay(el.getAttribute('data-end'), now.y);
      if (!start || !end) {
        el.hidden = !designMode();
        if (designMode()) console.warn('Corporate page: the holiday line needs two readable dates, such as 2026-11-01 and 2026-12-17.');
        return;
      }
      if (!end.hasYear && num(end) < num(start)) end.y += 1;
      el.hidden = !(designMode() || (num(now) >= num(start) && num(now) <= num(end)));
    });
  }

  function choose(root, want) {
    if (!want) return;
    want = want.toLowerCase().trim();
    root.querySelectorAll('[data-pw-cp-select]').forEach(function (sel) {
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.value && o.value.toLowerCase() === want) sel.value = o.value;
      });
    });
    root.querySelectorAll('[data-pw-cp-for-group] input[type="radio"]').forEach(function (r) {
      if (r.value.toLowerCase() === want) r.checked = true;
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-pw-cp-date]').forEach(function (el) {
      try { var t = nyToday(); el.min = t.y + '-' + ('0' + t.m).slice(-2) + '-' + ('0' + t.d).slice(-2); } catch (e) { /* no Intl time zones: leave the field open */ }
    });
    season(root);
    root.querySelectorAll('[data-pw-cp-for]').forEach(function (a) {
      a.addEventListener('click', function () { choose(document, a.getAttribute('data-pw-cp-for')); });
    });
    try { choose(root, new URLSearchParams(location.search).get('for')); } catch (e) { /* older browsers */ }
    var ok = root.querySelector('[data-pw-cp-success]');
    if (ok && /contact_posted=true/.test(location.search)) {
      try { ok.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();